import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { AgencyService } from '../common-theme/api/agency.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent extends SeoAwareBaseComponent implements OnInit {
  public isOpen: boolean[] = [true, false, false, false, false];
  public navLinks: any = [
    { path: '/despre-noi/istorie' },
    { path: '/despre-noi/proiect' },
    { path: '/despre-noi/facilitati' },
    { path: '/despre-noi/finisaje' }
  ];

  constructor(
    private router: Router,
    public agencyService: AgencyService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.meta.addTags([
      { name: 'robots', content: 'noindex' }
    ]);
    this.setTitle(this.agencyService.agency.name);
    this.router.navigate(['despre-noi/istorie']);
  }
}



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.ts